<header class="page-header">
  <div class="header-content">
    <div class="header-text">
      <div class="title-row">
        <h1 class="page-title">{{ title() }}</h1>

        @if (showTitleInfoIcon()) {
          <umss-icon-button
            iconName="phosphorWarningCircle"
            size="Regular"
            variant="Ghost"
            [umssTooltip]="titleInfoDialogTitle()"
            ariaLabel="Open page details"
            (onClick)="openTitleInfoDialog()"
          />
        }
      </div>

      @if (showDescription() && description()) {
        <p class="page-description">{{ description() }}</p>
      }
    </div>

    <div class="header-actions">
      @if (showSecondaryButton()) {
        <umss-button
          *umssHasPermission="secondaryPermissions()"
          [size]="secondaryButtonSize()"
          [variant]="secondaryButtonVariant()"
          [label]="showTextSecondaryButton() ? secondaryButtonText() : ''"
          [leftIconName]="secondaryButtonIcon()"
          [disabled]="disabledSecondaryButton()"
          (click)="onSecondaryButtonClick()"
        />
      }
      @if (showButton()) {
        <umss-button
          *umssHasPermission="permissions()"
          [size]="buttonSize()"
          [variant]="buttonVariant()"
          [label]="showTextPrimaryButton() ? buttonText() : ''"
          [leftIconName]="buttonIcon()"
          [disabled]="disabledButton()"
          (click)="onButtonClick()"
        />
      }
    </div>
  </div>

  @if (showTitleInfoIcon()) {
    <umss-dialog
      [open]="isTitleInfoDialogOpen()"
      [size]="'Small'"
      (onClose)="closeTitleInfoDialog()"
    >
      <umss-dialog-header [title]="titleInfoDialogTitle()" />
      <div class="title-info-dialog-content">
        <ng-content select="[pageHeaderInfo]"></ng-content>
      </div>
    </umss-dialog>
  }
</header>
